import { differenceInMinutes } from 'date-fns';

const timeDiffBetweenDates = (from, to) => {
  const start = new Date(from);
  const end = new Date(to);

  const totalMinutes = differenceInMinutes(end, start);

  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  const formattedDifference = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(
    2,
    '0'
  )} hs`;

  return formattedDifference;
};

export default timeDiffBetweenDates;
